import { useState, useEffect } from 'react';
import verifyForgotPasswordSecret from '../api/verifyForgotPasswordSecret';

export default function useValidateSecretManager(secret: string | undefined) {
    const [isValidatingLink, setIsValidatingLink] = useState(true);
    const [isValidLink, setIsValidLink] = useState(false);
    const [hasServerError, setHasServerError] = useState(false);

    const validateSecret = async (secretToValidate: string) => {
        const response = await verifyForgotPasswordSecret(secretToValidate);

        if (response.status && response.status === 500) {
            setHasServerError(true);
        } else if (response.status && response.status >= 400) {
            setIsValidLink(false);
        } else {
            setIsValidLink(true);
        }

        setIsValidatingLink(false);
    };

    useEffect(() => {
        if (!secret) {
            setIsValidLink(false);
            setIsValidatingLink(false);
            return;
        }

        validateSecret(secret);
    }, [secret]);

    return {
        isValidatingLink,
        isValidLink,
        hasServerError,
        setHasServerError
    };
}
